import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import * as pdfjsLib from "pdfjs-dist";
import "./DocumentViewer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const DocumentViewer = ({ url, fileType, onDownload }) => {
  const [numPages, setNumPages] = useState(0);
  const [pdfSrc, setPdfSrc] = useState(null);
  const containerRef = useRef(null);
  const scrollerRef = useRef(null);
  const [pdfWidth, setPdfWidth] = useState(0);

  useEffect(() => {
    setPdfSrc(url || null);
    // Always scroll to top when a new document URL is set
    if (scrollerRef.current) {
      scrollerRef.current.scrollTop = 0;
    }
  }, [url]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setPdfWidth(containerRef.current.offsetWidth);
      }
    };

    handleResize(); // initial
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadPdfAsBlob = async () => {
    try {
      if (!url) return;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      setPdfSrc(blobUrl);
    } catch (e) {
      console.error("Blob fallback failed:", e);
    }
  };

  const handleDownload = () => {
    if (!url) return;

    const fileName = url.split("/").pop().split("?")[0];

    // Force download for PDFs
    if (fileName.toLowerCase().endsWith(".pdf")) {
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        })
        .catch((err) => console.error("PDF download failed:", err));
    } else {
      // Normal direct download
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    // Still notify parent if needed
    if (onDownload) onDownload(url);
  };

  const getExtension = () => {
    if (fileType) return fileType.toLowerCase().replace(/^\./, "");
    if (!url) return "";
    const cleanUrl = url.split("?")[0].split("#")[0];
    return cleanUrl.split(".").pop().toLowerCase();
  };
  const ext = getExtension();
  if (!url) {
    return <div style={{ textAlign: "center" }}>No document to display</div>;
  }

  // return (
  //   <div style={{ textAlign: "center" }} className="DocViewer">
  //     {url ? (
  //       <>
  //         {ext === "pdf" ? (
  //           <div className="pdf-scroller">
  //             <Document
  //               file={pdfSrc || url}
  //               className="PdfViewer"
  //               scale={1.3}
  //               onLoadSuccess={onDocumentLoadSuccess}
  //               onLoadError={(err) => {
  //                 console.error("PDF load error:", err);
  //                 if (!pdfSrc) loadPdfAsBlob();
  //               }}
  //               loading="Loading PDF..."
  //             >
  //               {Array.from({ length: numPages || 0 }, (_, i) => (
  //                 <Page key={`page_${i + 1}`} pageNumber={i + 1} />
  //               ))}
  //             </Document>
  //           </div>
  //         ) : ext === "doc" || ext === "docx" || ext === "document" ? (
  //           <div className="doc-viewer-wrap">
  //             <DocViewer
  //               pluginRenderers={DocViewerRenderers}
  //               documents={[{ uri: url, fileType: ext }]}
  //               prefetchMethod="GET"
  //               config={{
  //                 header: { disableHeader: true, disableFileName: false },
  //                 pdfZoom: { defaultZoom: "page-width" },
  //               }}
  //             />
  //           </div>
  //         ) : (
  //           <div>Unsupported file format111111111111111</div>
  //         )}

  //        <div className="floatBtn" onClick={handleDownload}>
  //               <svg id="a852fdaa-156c-46c0-a3b6-364630b4c7fc" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 637.22 637.22">
  //                 <g>
  //                   <circle cx="318.61" cy="318.61" r="318.61" style={{ fill: "#404040" }} />
  //                   <g>
  //                     <path d="M363.11,176.87c0,19.08,0,38.16,0,57.24.05,22.81,16.39,39.29,39.21,39.45,16.08.12,32.15,0,48.23,0h4.55v74.13c-4.44,0-8.83-.12-13.22,0C414.6,348.65,390.4,358,369.14,375a15.67,15.67,0,0,1-10.62,3.64c-34.63-.15-69.26-.08-103.89-.08h-2.75c-6.49,0-10.1,2.62-10.11,7.28s3.6,7.29,10.1,7.29q46.85,0,93.7,0h4.81c-1.05,1.64-1.77,2.67-2.4,3.75-4.75,8.23-9.63,16.4-14.14,24.76-1.23,2.29-2.35,3.15-5,3.14-24.7-.11-49.4-.07-74.1-.07h-3.53c-5.92,0-9.33,2.59-9.45,7.09s3.36,7.35,9.54,7.38c9.15,0,18.29,0,27.44,0h48.67c-6.34,27.06-4.53,53.06,5.91,78.74H226.65c-11.18,0-20.73-3.61-27.76-12.68-4.94-6.37-6.73-13.71-6.73-21.63q0-55.68,0-111.34,0-80.37,0-160.75c0-14,5.62-24.78,18.32-31.26,3.07-1.57,6.59-2.27,9.91-3.37Zm-68.61,171q21.74,0,43.48,0a18.39,18.39,0,0,0,4.27-.34,6.94,6.94,0,0,0,5.4-7.19,6.76,6.76,0,0,0-6-6.64,26.72,26.72,0,0,0-4.29-.26h-85a29.08,29.08,0,0,0-4.67.3A6.49,6.49,0,0,0,242.1,339c-1.2,4.9,2.27,8.79,8.13,8.81C265,347.86,279.74,347.82,294.5,347.82Z" transform="translate(-43.92 -47.78)" style={{ fill: "#fff" }} />
  //                     <path d="M438.39,578.35c-6-1.08-12.13-1.8-18-3.3-44.26-11.19-76.92-48.47-81.52-92.81-5.67-54.73,28.63-103.38,82.56-117.09,39.89-10.14,85.49,6.15,110.29,39.15,17.35,23.07,25.37,49,21.79,77.52-5.32,42.52-28.34,72.51-68,88.79-9.86,4-20.88,5.24-31.36,7.74Zm16.36-65.57-1.36-.9v-4.12q0-47.22,0-94.46a33.32,33.32,0,0,0-.17-4.69,7.08,7.08,0,0,0-14-.23,28.14,28.14,0,0,0-.21,4.69q0,47.42,0,94.85v4l-1.16.55a36,36,0,0,0-2.33-3.11q-17.49-18.79-35-37.54a19.07,19.07,0,0,0-3.46-3.15A7.07,7.07,0,0,0,387,478.15a18.15,18.15,0,0,0,2.4,3.07q24.68,26.56,49.38,53.1c5.41,5.8,9,5.8,14.36,0q24.47-26.22,48.91-52.46a19.6,19.6,0,0,0,3.13-4c1.63-3.1,1.26-6.17-1.4-8.54a6.63,6.63,0,0,0-8.64-.63,19.83,19.83,0,0,0-3.43,3.18q-17.5,18.78-35,37.62A19.83,19.83,0,0,0,454.75,512.78Z" transform="translate(-43.92 -47.78)" style={{ fill: "#fff" }} />
  //                     <path d="M445.4,259.17c-15.7,0-30.2.26-44.68-.08-13.26-.32-22.61-9.85-23.05-23.82-.47-15.13-.09-30.29-.07-45.45,0-.22.19-.45.59-1.32Z" transform="translate(-43.92 -47.78)" style={{ fill: "#fff" }} />
  //                   </g>
  //                 </g>
  //               </svg>
  //             </div>

  //       </>
  //     ) : (
  //       <div>No document to display</div>
  //     )}
  //   </div>
  // );
  return (
    <div style={{ textAlign: "center" }} className="DocViewer">
      {url ? (
        <>
          {ext === "pdf" ? (
            // ✅ PDF preview using react-pdf
            // <div className="pdf-scroller">
            //   <Document
            //     file={pdfSrc || url}
            //     className="PdfViewer"
            //     scale={1.3}
            //     onLoadSuccess={onDocumentLoadSuccess}
            //     onLoadError={(err) => {
            //       console.error('PDF load error:', err);
            //       if (!pdfSrc) loadPdfAsBlob();
            //     }}
            //     loading="Loading PDF..."
            //   >
            //     {Array.from({ length: numPages || 0 }, (_, i) => (
            //       <Page key={`page_${i + 1}`} pageNumber={i + 1} />
            //     ))}
            //   </Document>
            // </div>
            <div
              className="pdf-scroller"
              ref={(el) => {
                containerRef.current = el;
                scrollerRef.current = el;
              }}
            >
              <Document
                file={pdfSrc || url}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(err) => {
                  console.error("PDF load error:", err);
                  if (!pdfSrc || pdfSrc === url) {
                    loadPdfAsBlob();
                  }
                }}
                loading="Loading PDF..."
              >
                {Array.from({ length: numPages || 0 }, (_, i) => (
                  <Page
                    key={`page_${i + 1}`}
                    pageNumber={i + 1}
                    scale={1}
                    width={pdfWidth > 0 ? Math.min(pdfWidth, 900) : undefined}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))}
              </Document>
            </div>
          ) : ["doc", "docx", "xls", "xlsx", "ppt", "pptx"]?.includes(ext) ? (
            // ✅ Open MS Office files in online viewer
            <div className="doc-viewer-wrap" >
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
                width="100%"
                height="100%"
                frameBorder="0"
                title="Office Viewer"
              />
            </div>
          ) : ["jpg", "jpeg", "png"]?.includes(ext) ? (
            // ✅ Image preview
            <img
              src={url}
              alt="Document Preview"
              style={{
                width: "100%",
                maxHeight: "700px",
                objectFit: "contain",
              }}
            />
          ) : (
            // ❌ Unsupported file type
            <div>Unsupported file format</div>
          )}

          <div
            className="floatBtn"
            onClick={handleDownload}
            title="Download File"
          >
            <svg
              id="a852fdaa-156c-46c0-a3b6-364630b4c7fc"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 637.22 637.22"
            >
              <g>
                <circle
                  cx="318.61"
                  cy="318.61"
                  r="318.61"
                  style={{ fill: "#404040" }}
                />
                <g>
                  <path
                    d="M363.11,176.87c0,19.08,0,38.16,0,57.24.05,22.81,16.39,39.29,39.21,39.45,16.08.12,32.15,0,48.23,0h4.55v74.13c-4.44,0-8.83-.12-13.22,0C414.6,348.65,390.4,358,369.14,375a15.67,15.67,0,0,1-10.62,3.64c-34.63-.15-69.26-.08-103.89-.08h-2.75c-6.49,0-10.1,2.62-10.11,7.28s3.6,7.29,10.1,7.29q46.85,0,93.7,0h4.81c-1.05,1.64-1.77,2.67-2.4,3.75-4.75,8.23-9.63,16.4-14.14,24.76-1.23,2.29-2.35,3.15-5,3.14-24.7-.11-49.4-.07-74.1-.07h-3.53c-5.92,0-9.33,2.59-9.45,7.09s3.36,7.35,9.54,7.38c9.15,0,18.29,0,27.44,0h48.67c-6.34,27.06-4.53,53.06,5.91,78.74H226.65c-11.18,0-20.73-3.61-27.76-12.68-4.94-6.37-6.73-13.71-6.73-21.63q0-55.68,0-111.34,0-80.37,0-160.75c0-14,5.62-24.78,18.32-31.26,3.07-1.57,6.59-2.27,9.91-3.37Zm-68.61,171q21.74,0,43.48,0a18.39,18.39,0,0,0,4.27-.34,6.94,6.94,0,0,0,5.4-7.19,6.76,6.76,0,0,0-6-6.64,26.72,26.72,0,0,0-4.29-.26h-85a29.08,29.08,0,0,0-4.67.3A6.49,6.49,0,0,0,242.1,339c-1.2,4.9,2.27,8.79,8.13,8.81C265,347.86,279.74,347.82,294.5,347.82Z"
                    transform="translate(-43.92 -47.78)"
                    style={{ fill: "#fff" }}
                  />
                  <path
                    d="M438.39,578.35c-6-1.08-12.13-1.8-18-3.3-44.26-11.19-76.92-48.47-81.52-92.81-5.67-54.73,28.63-103.38,82.56-117.09,39.89-10.14,85.49,6.15,110.29,39.15,17.35,23.07,25.37,49,21.79,77.52-5.32,42.52-28.34,72.51-68,88.79-9.86,4-20.88,5.24-31.36,7.74Zm16.36-65.57-1.36-.9v-4.12q0-47.22,0-94.46a33.32,33.32,0,0,0-.17-4.69,7.08,7.08,0,0,0-14-.23,28.14,28.14,0,0,0-.21,4.69q0,47.42,0,94.85v4l-1.16.55a36,36,0,0,0-2.33-3.11q-17.49-18.79-35-37.54a19.07,19.07,0,0,0-3.46-3.15A7.07,7.07,0,0,0,387,478.15a18.15,18.15,0,0,0,2.4,3.07q24.68,26.56,49.38,53.1c5.41,5.8,9,5.8,14.36,0q24.47-26.22,48.91-52.46a19.6,19.6,0,0,0,3.13-4c1.63-3.1,1.26-6.17-1.4-8.54a6.63,6.63,0,0,0-8.64-.63,19.83,19.83,0,0,0-3.43,3.18q-17.5,18.78-35,37.62A19.83,19.83,0,0,0,454.75,512.78Z"
                    transform="translate(-43.92 -47.78)"
                    style={{ fill: "#fff" }}
                  />
                </g>
              </g>
            </svg>
          </div>
        </>
      ) : (
        <div>No document to display</div>
      )}
    </div>
  );
};

export default DocumentViewer;
